import { createSelector } from 'reselect';
import { __, get, isEmpty, map, set } from 'lodash/fp';
import { TimeUnitUtils, composeProps, createPropsExtender } from '@mews/framework';
import { TimeUnit } from '@mews/enums';
import { utcToLocalizedDate } from '@mews-commander/utils';
import { getTimeUnitRangeArrayFromUtc } from '@mews-commander/legacy-entities/src/selectors/session/dateTime';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { moduleSelector } from '../module';
import { getSelectedServiceTimeUnit } from './data';

const getFilters = createSelector(moduleSelector, get('filters'));

export const getFiltersDateRange = createSelector(getFilters, get('dateRange'));
export const getLocalizedFiltersDateRange = createSelector(
    getFiltersDateRange,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    ({ startUtc, endUtc }, timezone) => ({
        startDate: utcToLocalizedDate(startUtc, timezone),
        endDate: utcToLocalizedDate(endUtc, timezone),
    })
);

export const getStartUtcFilterValue = createSelector(getFiltersDateRange, get('startUtc'));
export const getEndUtcFilterValue = createSelector(
    getFiltersDateRange,
    getSelectedServiceTimeUnit,
    getCurrentEnterpriseIanaTimeZoneIdentifier,
    (dateRange, timeUnit, timezone: string) => {
        const endUtc = get('endUtc', dateRange);
        if (timeUnit === TimeUnit.Hour) {
            return TimeUnitUtils.addTimeUnitToUtc(endUtc, timezone, TimeUnit.Day, 1);
        }
        return endUtc;
    }
);

const composeUtcDateRangeFromProps = createPropsExtender('utcDateRange', getFiltersDateRange);

export const getTimeUnitRangeArray = composeProps(
    // @ts-expect-error $TSFixMeError: Expected 1 arguments, but got 2.
    (state, props) => (isEmpty(props.utcDateRange) ? [] : getTimeUnitRangeArrayFromUtc(state, props)),
    composeUtcDateRangeFromProps
);

export const getDateTimeRange = createSelector(
    composeProps(getTimeUnitRangeArray, createPropsExtender('timeUnit', getSelectedServiceTimeUnit)),
    map(set('date', __, {}))
);
